import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

// 액션 타입을 정의해줍니다.
const INIT_USER_STATE = 'uesrInfoAction/initUserState';
const UPDATE_USER_STATE = 'uesrInfoAction/updateUserState';
const UPDATE_USER_ROLE = 'uesrInfoAction/updateRole';
const UPDATE_USER_DEVICE_INFO = 'uesrInfoAction/updateDeviceInfo';

// 액션 생성 함수를 만듭니다.
export const initUserState = createAction(INIT_USER_STATE);
export const updateUserState = createAction(UPDATE_USER_STATE);
export const updateRole = createAction(UPDATE_USER_ROLE);
export const updateDeviceInfo = createAction(UPDATE_USER_DEVICE_INFO);

// 모듈의 초기 상태를 정의합니다.
const initialState = {
  name : "",
  id : null,
  isLogin : false,
  email : "",
  profile_img : "",
  achievement_goal : "",
  role : "member",
  exp_point : 0,
  isApp: null,
  isMobile: null,
  deviceType: null,
};


// immer 를 사용하여 값을 수정하는 리듀서입니다.
export default handleActions({
  [INIT_USER_STATE]: (state, action) => {
    return produce(state, draft => {
      draft.name = "";
      draft.id = null;
      draft.isLogin = false;
      draft.email = "";
      draft.achievement_goal = "";
      draft.profile_img =  "";
      draft.exp_point = 0; 
      draft.role = "member"; 
    });
  },
  [UPDATE_USER_STATE]: (state, action) => {
    return produce(state, draft => {
      draft.name =(action.payload.name !== undefined && action.payload.name !== null) ?  action.payload.name: draft.name;
      draft.id = (action.payload.id !== undefined && action.payload.id !== null) ? action.payload.id: draft.id;
      draft.isLogin = (action.payload.isLogin !== undefined && action.payload.isLogin !== null) ? action.payload.isLogin : draft.isLogin;
      draft.email = (action.payload.email !== undefined && action.payload.email !== null) ? action.payload.email : draft.email;
      draft.achievement_goal = (action.payload.achievement_goal !== undefined && action.payload.achievement_goal !== null) ?  action.payload.achievement_goal : draft.achievement_goal;
      draft.profile_img =  (action.payload.profile_img !== undefined && action.payload.profile_img !== null) ? action.payload.profile_img: draft.profile_img;
      draft.exp_point = (action.payload.exp_point !== undefined && action.payload.exp_point !== null) ? action.payload.exp_point : draft.exp_point;
      draft.isApp = (action.payload.isApp !== undefined && action.payload.isApp !== null) ? action.payload.isApp : draft.isApp;
      draft.deviceType = (action.payload.deviceType !== undefined && action.payload.deviceType !== null) ? action.payload.deviceType : draft.deviceType;
    });
  },
  [UPDATE_USER_ROLE]: (state, action) => {
    return produce(state, draft => {
      draft.role = action.payload.role;
    });
  },
  [UPDATE_USER_DEVICE_INFO]: (state, action) => {
    return produce(state, draft => {
      draft.isApp = (action.payload.isApp !== undefined && action.payload.isApp !== null) ? action.payload.isApp : draft.isApp;
      draft.isMobile = (action.payload.isMobile !== undefined && action.payload.isMobile !== null) ? action.payload.isMobile : draft.isMobile;
      draft.deviceType = (action.payload.deviceType !== undefined && action.payload.deviceType !== null) ? action.payload.deviceType : draft.deviceType;
    });
  },
}, initialState);